import {
    genericPage,
    getServerSidePropsHelper,
    getMappingEleccions3CatInfo,
    getSlugEleccio,
    getBasePathEleccio
} from 'components/3catinfo/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import { usePageEditMode } from 'hooks/usePageEditMode';

const path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions'];

const Pagina = (props) => {
    const router = useRouter();
    const genericPageProps = usePageEditMode(props, router);
    return genericPage(genericPageProps, router, path);
};

export async function getServerSideProps(context) {
    const { preview } = context.query;
    const basePath = getBasePathEleccio(context?.resolvedUrl);
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }

    const estat = preview || mapping.fase;

    let path = [...basePath, 'home', 'seo'];
    if (estat === 'escrutini') {
        path = [...basePath, 'home', 'escrutini'];
    } else if (estat === 'sondeig') {
        path = [...basePath, 'home', 'sondeig'];
    } else if (estat === 'final') {
        path = [...basePath, 'home', 'final'];
    }

    const options = {
        slugs: path,
        id: mapping.id
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
